import { ProductFilterKey, ProductFilterModel } from '../domain';
import { useFilter } from '../../filter';

export const useProductFilter = () => {
  return useFilter(
    ProductFilterKey,
    'productFilter',
    (filter: any) => new ProductFilterModel(filter),
    true
  );
};
